enum ShowOnly {
	TOUTES_LIGNES = 0,
	LIGNES_AVEC_MONTANT = 1,
	LIGNES_SAISIES = 2,
	LIGNES_NEGATIVES_SAISIES = 3,
}

export default ShowOnly;
